import React from 'react'

import { CSSObject } from '@emotion/styled'
import { TFunction } from 'i18next'

import { Box, Text, ProgressBar, Theme } from '@surglogs-app/ui'

interface LoginMFASetupProgressBarProps {
  currentStep: number
  maxSteps: number
  t: TFunction<any>
  w?: keyof Theme['ui']['spacings'] | CSSObject['width']
}

export const MfaSetupProgressBar = ({
  currentStep,
  maxSteps,
  w,
  t,
}: LoginMFASetupProgressBarProps) => {
  return (
    <Box {...{ w, ta: 'end' }}>
      <Text {...{ bold: true }}>{`${t(
        'mfaSetup.step',
      )} ${currentStep}/${maxSteps}`}</Text>
      <ProgressBar
        {...{ percentage: (currentStep / maxSteps) * 100, mt: 'sm' }}
      />
    </Box>
  )
}
